"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSuggestions = exports.transformRecentSearchesSuggestions = exports.substituteValues = exports.removeRecentSearchStations = exports.removeDuplicateStations = exports.mapKiwiRequiredLanguage = exports.mapKiwiRequiredCurrency = exports.isDepartKiwiStationCheck = exports.isArrivalAAGoStationCheck = exports.isAAGoRoute = exports.getSuggestionType = exports.getSuggestionSubtitle = exports.getStationObjectFromCode = exports.getLabelBasedOnLocale = exports.getDestinationAirportsObject = exports.getDestinationAirportsList = exports.formatUrl = exports.format = exports.addStationsLabelIcon = exports.addRecentSearchLabelIcon = exports.addRecentSearchDestinationLabelIcon = exports.addNearestAirportLocationIcon = exports.addFlyBeyondIconRecentSearches = exports.addDestinationStationsIcon = exports.SUGGESTION_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _crossPlatformComponents = require("@airasia/cross-platform-components");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
* Get StationName from the ArrayList of Station based on Station Code
* */
var getStationObjectFromCode = function getStationObjectFromCode(stationCode) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var key = "StationCode";

  if (data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].StationCode.toLowerCase() === stationCode.toLowerCase()) {
        return data[i];
      }
    }

    return null;
  } else return null;
};

exports.getStationObjectFromCode = getStationObjectFromCode;

var getDestinationAirportsList = function getDestinationAirportsList(data) {
  var destinationObject = {};
  Object.keys(data).map(function (key) {
    Object.keys(data[key]).map(function (item) {
      destinationObject[item] = {
        HIPS: data[key][item].HIPS
      };
    });
  });
  return destinationObject;
};

exports.getDestinationAirportsList = getDestinationAirportsList;

var getDestinationAirportsObject = function getDestinationAirportsObject(allStationsList, destinationObject) {
  var destinationList = [];
  destinationList = allStationsList.filter(function (data) {
    var key = data.StationCode;

    if (destinationObject.hasOwnProperty(key)) {
      data.HIPS = destinationObject[key]["HIPS"];
      return data;
    }
  });
  return destinationList;
};

exports.getDestinationAirportsObject = getDestinationAirportsObject;

var removeDuplicateStations = function removeDuplicateStations(stationWithDuplicate) {
  var stationListWithoutDuplicate = new Set();
  var finalStationsList = [];
  stationWithDuplicate.map(function (station) {
    stationListWithoutDuplicate.add(station.StationCode);
  });
  stationListWithoutDuplicate.forEach(function (code) {
    finalStationsList.push(getStationObjectFromCode(code, stationWithDuplicate));
  });
  return finalStationsList;
};

exports.removeDuplicateStations = removeDuplicateStations;

var removeByAttr = function removeByAttr(arr, attr, value) {
  var i = arr.length;

  while (i--) {
    if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
      arr.splice(i, 1);
    }
  }

  return arr;
};

var removeRecentSearchStations = function removeRecentSearchStations(recentSearches, stationsList) {
  var updatedStations = stationsList;
  recentSearches.map(function (search) {
    updatedStations = removeByAttr(updatedStations, "StationCode", search.StationCode);
  });
  return updatedStations;
};

exports.removeRecentSearchStations = removeRecentSearchStations;

var format = function format(source, params) {
  params.forEach(function (n, i) {
    source = source.replace(new RegExp("\\{" + i + "\\}", "g"), n);
  });
  return source;
};

exports.format = format;

var formatUrl = function formatUrl(source, params) {
  var formatedParams = params.map(function (param) {
    return encodeURIComponent(param);
  });
  return format(source, formatedParams);
};

exports.formatUrl = formatUrl;
var SUGGESTION_TYPES = {
  AIRPORT: 'airport',
  CITY: 'city',
  LANDMARK: 'landmark',
  NEIGHBORHOOD: 'neighborhood',
  REGION: 'region',
  HOTEL: 'hotel'
};
exports.SUGGESTION_TYPES = SUGGESTION_TYPES;

var getSuggestionType = function getSuggestionType(suggestion) {
  switch (suggestion.type) {
    case SUGGESTION_TYPES.AIRPORT:
      return _crossPlatformComponents.AaIconTypes.AIRPORT;

    case SUGGESTION_TYPES.CITY:
    case SUGGESTION_TYPES.LANDMARK:
    case SUGGESTION_TYPES.NEIGHBORHOOD:
    case SUGGESTION_TYPES.REGION:
    case SUGGESTION_TYPES.HOTEL:
      return _crossPlatformComponents.AaIconTypes.LOCATION;

    default:
      return '';
  }
};

exports.getSuggestionType = getSuggestionType;

var getSuggestionSubtitle = function getSuggestionSubtitle(suggestion) {
  var name = suggestion.name,
      full_name = suggestion.full_name;
  return full_name.replace("".concat(name, ", "), '');
};

exports.getSuggestionSubtitle = getSuggestionSubtitle;

var transformSuggestions = function transformSuggestions(suggestions, suggestionTypesTranslation) {
  return suggestions.map(function (suggestion) {
    var labelIcon = getSuggestionType(suggestion);
    var subtitle = getSuggestionSubtitle(suggestion);
    var type = suggestionTypesTranslation[suggestion.type];
    return _objectSpread(_objectSpread({}, suggestion), {}, {
      labelIcon: labelIcon,
      subtitle: subtitle,
      type: type,
      typeWithoutTranslation: suggestion.type
    });
  }).filter(function (_ref) {
    var labelIcon = _ref.labelIcon;
    return labelIcon !== '';
  });
};

exports.transformSuggestions = transformSuggestions;

var transformRecentSearchesSuggestions = function transformRecentSearchesSuggestions(recentSearches, suggestionTypesTranslation) {
  return recentSearches.map(function (_ref2) {
    var destination = _ref2.destination;
    return _objectSpread(_objectSpread({}, destination), {}, {
      labelIcon: _crossPlatformComponents.AaIconTypes.RECENT_SEARCH,
      subtitle: getSuggestionSubtitle(destination),
      type: suggestionTypesTranslation[destination.type],
      typeWithoutTranslation: destination.type
    });
  });
};

exports.transformRecentSearchesSuggestions = transformRecentSearchesSuggestions;

var addStationsLabelIcon = function addStationsLabelIcon(stationList) {
  var clonedArray = stationList.map(function (item) {
    return _objectSpread({}, item);
  });
  clonedArray.forEach(function (station) {
    switch (station.StationType.toLowerCase()) {
      case "a":
        station.labelIcon = _crossPlatformComponents.AaIconTypes.FLIGHT_ICON;
        break;

      case "f":
        station.labelIcon = _crossPlatformComponents.AaIconTypes.ISLAND_TRANSFER;
        break;

      case "b":
        station.labelIcon = _crossPlatformComponents.AaIconTypes.CITY_TRANSFER;
        break;
    }
  });
  return clonedArray;
};

exports.addStationsLabelIcon = addStationsLabelIcon;

var addFlyBeyondIconRecentSearches = function addFlyBeyondIconRecentSearches(stationList) {
  var stationNewList = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    if (!newObj.AAFlight && newObj.AAFlight !== undefined) {
      console.log("data : ", newObj.AAFlight, !newObj.AAFlight);
      newObj.labelIndicator = _crossPlatformComponents.AaIconTypes.OTHER_AIRLINES;
      newObj.labelTextStyle = {
        color: "#2f73d2"
      };
    }

    stationNewList.push(newObj);
  });
  return stationNewList;
};

exports.addFlyBeyondIconRecentSearches = addFlyBeyondIconRecentSearches;

var addDestinationStationsIcon = function addDestinationStationsIcon(stationList) {
  var destinationNewList = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    if (newObj.AAFlight === true || newObj.AAFlight === undefined) {
      newObj.labelIcon = _crossPlatformComponents.AaIconTypes.FLIGHT_ICON;
    } else {
      newObj.labelIcon = _crossPlatformComponents.AaIconTypes.FLIGHT_ICON_BLUE;
      newObj.labelIndicator = _crossPlatformComponents.AaIconTypes.OTHER_AIRLINES;
      newObj.labelTextStyle = {
        color: "#2f73d2"
      };
    }

    destinationNewList.push(newObj);
  });
  return destinationNewList;
};

exports.addDestinationStationsIcon = addDestinationStationsIcon;

var addRecentSearchLabelIcon = function addRecentSearchLabelIcon(stationList) {
  var recentSearchStations = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    newObj.labelIcon = _crossPlatformComponents.AaIconTypes.RECENT_SEARCH;
    recentSearchStations.push(newObj);
  });
  return recentSearchStations;
};

exports.addRecentSearchLabelIcon = addRecentSearchLabelIcon;

var addNearestAirportLocationIcon = function addNearestAirportLocationIcon(stationList) {
  var nearestAirports = [];
  stationList.forEach(function (station) {
    var newObj = _objectSpread({}, station);

    newObj.labelIcon = _crossPlatformComponents.AaIconTypes.LOCATION;
    nearestAirports.push(newObj);
  });
  return nearestAirports;
};

exports.addNearestAirportLocationIcon = addNearestAirportLocationIcon;

var addRecentSearchDestinationLabelIcon = function addRecentSearchDestinationLabelIcon(stationList) {
  stationList.forEach(function (station) {
    station.labelIcon = _crossPlatformComponents.AaIconTypes.RECENT_SEARCH;
  });
  return stationList;
};

exports.addRecentSearchDestinationLabelIcon = addRecentSearchDestinationLabelIcon;

var resolve = function resolve(path, obj) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  var properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce(function (prev, curr) {
    return prev && prev[curr];
  }, obj);
};

var getLabelBasedOnLocale = function getLabelBasedOnLocale(key, localeData) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return resolve(key, localeData, '.') || defaultValue;
};

exports.getLabelBasedOnLocale = getLabelBasedOnLocale;

var isAAGoRoute = function isAAGoRoute(destination) {
  var key = "HIPS"; // console.log("from Aahelper:destination", destination)

  if (!destination.hasOwnProperty(key) || destination[key] === undefined) {
    return false;
  }

  if (destination[key]) {
    //HIPS->TRUE
    return false;
  } else if (!destination[key]) {
    return true;
  }
};

exports.isAAGoRoute = isAAGoRoute;

var mapKiwiRequiredCurrency = function mapKiwiRequiredCurrency(currency) {
  var currencies = ["BDT", "BND", "MOP"];

  if (currencies.indexOf(currency.toUpperCase()) > -1) {
    return "USD";
  }

  return currency.toUpperCase();
};

exports.mapKiwiRequiredCurrency = mapKiwiRequiredCurrency;

var mapKiwiRequiredLanguage = function mapKiwiRequiredLanguage(language) {
  var languageMapping = {
    "zh-cn": "cn",
    "zh-hk": "hk",
    "zh-tw": "tw",
    "ja-jp": "ja",
    "vi-vn": "vn",
    "ko-kr": "ko",
    "en-gb": "en",
    "th-th": "th",
    "ms-my": "my",
    "id-id": "id"
  };
  return languageMapping[language];
};

exports.mapKiwiRequiredLanguage = mapKiwiRequiredLanguage;

var substituteValues = function substituteValues(inputString, data) {
  var output = inputString.replace(/{[^{}]+}/g, function (match) {
    if (match in data) {
      return data[match];
    } else {
      return "";
    }
  });
  return output;
};

exports.substituteValues = substituteValues;

var isDepartKiwiStationCheck = function isDepartKiwiStationCheck(departStation) {
  var key = "AAFlight";

  if (!departStation.hasOwnProperty(key) || departStation[key] === undefined || departStation[key]) {
    return false;
  } else {
    return true;
  }
};

exports.isDepartKiwiStationCheck = isDepartKiwiStationCheck;

var isArrivalAAGoStationCheck = function isArrivalAAGoStationCheck(arrivalStation) {
  var key = "HIPS";

  if (!arrivalStation.hasOwnProperty(key) || arrivalStation[key] === undefined || arrivalStation[key]) {
    return false;
  } else {
    return true;
  }
};

exports.isArrivalAAGoStationCheck = isArrivalAAGoStationCheck;